<!-- « Carte » n'apparaît pas tant que le Mode Carte n'existe pas : une
     pastille grisée sans action était un cul-de-sac.
     Colonnes égales, autant que d'actions : quatre tiennent à 390 px. -->
<div class="mx-4 grid grid-flow-col auto-cols-fr items-center gap-2">
  <vw-app-menu-item
    [label]="'common.modals.ai-actions.content.actions.scan'"
    (click)="scanClicked()"
  >
    <vw-scan-barcode-icon class="icon" iconTemplate></vw-scan-barcode-icon>
  </vw-app-menu-item>
  <vw-app-menu-item
    [label]="'common.modals.ai-actions.content.actions.add'"
    (click)="addClicked()"
  >
    <vw-circle-plus-icon
      class="icon text-primary"
      iconTemplate
    ></vw-circle-plus-icon>
  </vw-app-menu-item>
  <vw-app-menu-item
    [label]="'common.modals.ai-actions.content.actions.tasks'"
    (click)="showTasksClicked()"
  >
    <vw-task-icon iconTemplate></vw-task-icon>
  </vw-app-menu-item>
</div>
